import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "cdp-expert-agent";
const keys = addTranslations(RESOURCE_NAME, {
    ask_me_anything: {
        en: "Ask anything about CDP",
        fr: "Posez une question sur CDP",
    },
    empty_state_title: {
        en: "CDP coach",
        fr: "Coach CDP",
    },
    title_chip_title: {
        en: "CDP coach",
        fr: "Coach CDP",
    },
    score_response_success: {
        en: "Feedback sent successfully",
        fr: "Feedback envoyé avec succès",
    },
    score_response_error: {
        en: "Feedback not sent",
        fr: "Feedback non envoyé",
    },
    error_message: {
        en: "Something went wrong, and the CDP coach can't continue the conversation. To keep using it, you'll need to reload the page. \n Important: Reloading will erase your current conversation. If there's anything you want to keep, please copy the text and save it elsewhere.",
        fr: "Une erreur inattendue est survenue et le coach CDP ne peut pas continuer la conversation. Pour continuer à l'utiliser, vous devrez recharger la page. \n Important: Le rechargement effacera votre conversation actuelle. Si vous souhaitez conserver quelque chose, veuillez copier le texte et l'enregistrer ailleurs.",
    },
    example_message_chip_questionnaire: {
        en: "How do we know which CDP questionnaire to complete?",
        fr: "Comment savoir quel questionnaire nous devons remplir ?",
    },
    example_message_chip_deadlines: {
        en: "What are the key deadlines of CDP this year?",
        fr: "Quelles sont les principales échéances du CDP cette année ?",
    },
    example_message_chip_climate_risk: {
        en: "How do we respond to CDP questions on climate risk and opportunities?",
        fr: "Comment répondre aux questions du CDP sur les risques et opportunités climatiques ?",
    },
});

export function useCdpExpertAgentTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
